import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import { useQuery } from "@vue/apollo-composable";
import { queries } from "@/apollo";
import { customMoment } from "@/main";
import { User, TtPage } from "@/CodegenTypes";
import { formatCount } from "@/helpers/formatCount";
import { startCase, sortBy, groupBy } from "lodash";
import TTPageDetailsModal from "../bet-details/TTPageDetailsModal.vue";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'TTCopyBetModal',
  props: {
    value: { type: Boolean, default: false },
    userId: null
  },
  emits: ["input", "copy"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", val: boolean): void;
  (e: "copy", page: TtPage): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: boolean, userId: User["userId"] };





const { $t } = useTranslation();
const t = (text: string) => $t(text);

const selectedPage = ref<null | TtPage>(null);
const showPageDetailModal = ref(false);

const releaseDateStart = customMoment()
  .add(-3, "weeks")
  .startOf("day")
  .toDate();

const releaseDateEnd = customMoment()
  .startOf("day")
  .toDate();

const queryVariables = computed(() => ({
  releaseDateStart,
  releaseDateEnd,
  behalfOf: props.userId,
}));

const { result, loading: apolloLoading, refetch } = useQuery<{ user: User }>(
  queries.userTtPages,
  queryVariables,
  {
    enabled: computed(() => !!props.userId && !!props.value),
    fetchPolicy: "cache-and-network",
  }
);

const user = computed(() => result.value?.user ?? null);

const processedPages = computed(() =>
  sortBy(user.value?.ttPages ?? [], (page) => -customMoment(page.createdAt).unix())
);

const processedPagesByReleaseDate = computed(() => {
  return Object.entries(groupBy(processedPages.value, (page) => page.releaseDate))
    .sort(([releaseDateA], [releaseDateB]) => {
      return customMoment(releaseDateB).unix() - customMoment(releaseDateA).unix();
    })
    .map(([releaseDate, pages]) => {
      const unitCount = pages.reduce((acc, page) => acc + page.calculation.unit, 0);
      return {
        releaseDate,
        pages,
        agg: {
          unitCount,
        },
      };
    })
    .sort((a, b) => {
      return customMoment(b.releaseDate).unix() - customMoment(a.releaseDate).unix();
    });
});

function openPage(page: TtPage) {
  selectedPage.value = page;
  showPageDetailModal.value = true;
}

function toggleModal(val: boolean) {
  emit("input", val);
}

function handleSubmit() {
  toggleModal(!props.value);
}

function formatDatetime(dateStr: string | Date) {
  return customMoment(dateStr).fromNow();
}

function formatReleaseDate(dateStr: string | Date) {
  return customMoment(dateStr).format("ddd, DD/MM/YYYY");
}

function reloadAll() {
  refetch(queryVariables.value);
}

function handleCopy(id: TtPage["id"]) {
  const page = user.value?.ttPages.find((page) => page.id === id);
  if (!page) {
    return;
  }
  emit("copy", page);
  toggleModal(false);
}

return { __sfc: true,props, emit, $t, t, selectedPage, showPageDetailModal, releaseDateStart, releaseDateEnd, queryVariables, result, apolloLoading, refetch, user, processedPages, processedPagesByReleaseDate, openPage, toggleModal, handleSubmit, formatDatetime, formatReleaseDate, reloadAll, handleCopy, formatCount, startCase, TTPageDetailsModal }
}

})